import React, { useState } from 'react';
import styles from "./styles.module.scss";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import { labelSyle } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant';
import { steps } from './constants';
import { inputAmountStyle } from '../sapPurchaseGrn/constant';
import CustomUpload from '../sapPurchaseOrder/CustomUpload';
import CustomDownload from '../sapPurchaseOrder/CustomDownload';
import { downloadFileHandler } from '../sapPurchaseGrn/Header';

const Header = ({
    headerRows = {},
    itemNo,
    headerFormHandler,
    fileData,
    setFileData,
    serviceEntryType,
    plant,
    netPrice,
    setIsDownloaded
}) => {

    const [currentStep, setCurrentStep] = useState(0);

    const handleHeaderTab = (index) => {
        setCurrentStep(index)
    }

    return (
        <>
            <div className={`mt-2 ${styles["stepper_grn"]}`}>
                {steps.map((item, index) => (
                    <div
                        key={index}
                        className={`step ${index === currentStep ? "active" : ""}`}
                        onClick={() => handleHeaderTab(index)}
                    >
                        <div className="step-text flex ">
                            {item}</div>
                    </div>
                ))}
            </div>

            <div className='d-flex mt-2'>
                {currentStep == 0 && (
                    <>
                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.poNumber}
                                handler={(value) => {
                                    headerFormHandler("poNumber", value);
                                }}
                                placeholder=""
                                label='Po Number'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.itemNo}
                                // handler={(value) => {
                                //     headerFormHandler("lineItem", value);
                                // }}
                                placeholder=""
                                label='Line Item'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>

                        {serviceEntryType === 'ariba' &&
                            <>
                                <div className={`${styles["header-column"]}`}>
                                    <AInput
                                        type="text"
                                        value={headerRows?.entrySheetNumber}
                                        handler={(value) => {
                                            headerFormHandler("entrySheetNumber", value);
                                        }}
                                        placeholder=""
                                        label='Entry Sheet Number'
                                        labelStyle={labelSyle}
                                        style={inputAmountStyle}
                                        disabled={serviceEntryType !== 'createSE'}

                                    />
                                </div>
                            </>}

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={plant}
                                // handler={(value) => {
                                //     headerFormHandler("lineItem", value);
                                // }}
                                placeholder=""
                                label='plant'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.shortText}
                                handler={(value) => {
                                    headerFormHandler("shortText", value);
                                }}
                                placeholder=""
                                label='Short Text'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={serviceEntryType !== 'createSE'}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <CustomDatePickerV2
                                placeHolder=""
                                value={headerRows?.docDate ?? ''}
                                width={"18px"}
                                handler={(index, date, keyName) => {
                                    headerFormHandler("docDate", date);
                                }}
                                label="Document Date"
                                labelStyle={labelSyle}
                                disabled={!['createSE', 'ariba'].includes(serviceEntryType)}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <CustomDatePickerV2
                                placeHolder=""
                                value={headerRows?.postingDate ?? ''}
                                width={"18px"}
                                handler={(index, date, keyName) => {
                                    headerFormHandler("postingDate", date);
                                }}
                                label="Posting Date"
                                labelStyle={labelSyle}
                                disabled={serviceEntryType !== 'createSE'}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.reference}
                                handler={(value) => {
                                    headerFormHandler("reference", value);
                                }}
                                placeholder=""
                                label='Reference'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={!["createSE"].includes(serviceEntryType)}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.docText}
                                handler={(value) => {
                                    headerFormHandler("docText", value);
                                }}
                                placeholder=""
                                label='Doc Text'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={!["createSE"].includes(serviceEntryType)}
                            />
                        </div>

                    </>
                )}
                {currentStep == 1 && (
                    <>
                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={netPrice}
                                handler={(value) => {
                                    headerFormHandler("netPrice", value);
                                }}
                                placeholder=""
                                label='Total Value'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>
                    </>
                )}
                {currentStep == 2 && (
                    <>
                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.vendor}
                                handler={(value) => {
                                    headerFormHandler("vendor", value);
                                }}
                                placeholder="Enter"
                                label='Vendor'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>

                        <div className={`${styles["header-column"]}`}>
                            <AInput
                                type="text"
                                value={headerRows?.receivingVendor}
                                handler={(value) => {
                                    headerFormHandler("receivingVendor", value);
                                }}
                                placeholder="Enter"
                                label='Receiving Vendor'
                                labelStyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>
                    </>
                )}
                {currentStep == 3 && (
                    <>

                        <div className={`${styles["header-column"]}`} style={{ width: "30%" }}>
                            {
                                (serviceEntryType === 'createSE' || serviceEntryType === 'ariba') ? (
                                    <div className={`${styles["upload-btn-style"]}`}>
                                        <CustomUpload
                                            fileData={fileData}
                                            setFileData={setFileData}
                                            id={"service-sheet"} />
                                    </div>
                                ) : (
                                    <CustomDownload
                                        fileData={fileData}
                                        onClick={() => downloadFileHandler(fileData, setIsDownloaded)}
                                    />
                                )
                            }
                        </div>

                    </>
                )}
            </div >
        </>
    )
}

export default Header;